
<template lang="pug">
	b-container.summary-view(fluid)
		BasicHeader(title="Entity Summary" :subTitle="getContractName" @back="$router.go(-1)")
		b-row.chart-section
			b-col
				chartsIface.chartCon(:chart='chartDataArray')
</template>

<style lang="scss" scoped>
.barChart{
	margin:auto;
	width: 100%;
	height: 70%;
	display: flex;


}
// .chartWithLegend{
// 		margin: auto;
// 		height: 70%;
// 		display: flex;
// }


</style>

<script>
import formatNumberReal from '@/lib/utils/formatNumberReal';
import chartsIface from '@/components/charts/chartsIface';
import colors from '@/assets/js/colors';
import BasicHeader from '@/components/general/BasicHeader';


export default {
	 name       : 'entity-summary',
	 components : {
		chartsIface, 
    BasicHeader,
	},

	computed : {
		chartDataArray() {
			try {
				console.log('chart data array');
				const rdata = [];
				let odata=this.getPayableYieldData();
				console.log('payableYeildData');
				console.log(odata);
				let tdata = odata.data.map( obj => ({
					barValues : [obj.value],
					barColors : [obj.barColor],
					barSuffixs: ['lbs'],
					barLabel  : obj.label
				}));
				console.log('tdata');
				console.log(tdata);
				odata = [];
				let data={
					id : 'F99A09BC-423E-35CD-39D2-B53D9427CFAB',
					label : odata.label,
					leftLabel: 'lbs',
					header:20,
					left:0,
					right:12,
					footer:10,
					title:"Payable Yield Trends",
					subtitle: 'This shows your payable yield yearly.',
					barType: 'normal',
					barDims: {
						barWidth  : "6",
						barMargin : "6.4",
						barGroupMargin: ".2",
					},
					chartSelects: {
						chartItems: [
							{
								barGroups: tdata
							}
						],
						selectLabel: null,
					}

				};
				rdata.push(data);

				console.log('AllQualitySummaryData');
				odata=this.getAllQualitySummaryData();
				console.log(odata);
				console.log('QualitySummary');
				console.log(odata);
				const bColors = ['#E5BF11', '#80Ab2C', '#F8A79E'];
				tdata = odata.allData.map( obj => ({
					barGroups: obj.data.map( (lobj, li) => ({
						barValues : [lobj.value],
						barColors : [bColors[li]],
						barSuffixs: ['lbs'],
						barLabel  : lobj.label
					})),
					selectValue: obj.year
				}));
				console.log('tdata');
				console.log(tdata);
				odata = [];
				data={
					id : '8F216769-43A1-37C6-0EC3-4468163A11EA',
					label : odata.label,
					leftLabel: 'lbs',
					header:20,
					left:0,
					right:12,
					footer:10,
					legendLabel: 'lbs',
					title:"Quality Summary",
					subtitle: 'This is the quality of crop you produced by year.',
					barType: 'normal',
					barDims: {
						barWidth  : "12",
						barMargin : "6.4",
						barGroupMargin: ".2",
					},
					chartSelects: {
						chartItems: tdata,
						selectLabel: 'Year',
						selectOptions: {
							color: 'red'
						},
					}

				};
				console.log('CHECKME');
				console.log(data);
				rdata.push(data);
				
				odata=this.getAllInsectDamageData();
				console.log('getAllInsectDamageData');
				console.log(odata);
				tdata = odata.data.map( obj => ({
					barValues : [obj.percent*100],
					barColors : bColors,
					barSuffixs: ['lbs'],
					barLabel  : obj.label,
					barString : [`${formatNumberReal(obj.percent*100)}% (${formatNumberReal(obj.value)}lbs)`]
				}));
				console.log('tdata');
				console.log(tdata);
				odata = [];
				data={
					id : 'C1AD4092-8722-3382-96D3-7CF8CF26A394',
					label : odata.label,
					leftLabel: '',
					header:20,
					left:0,
					right:12,
					footer:10,
					title:"Total Insect",
					subtitle: 'This shows the amount of product impacted by insect damage.',
					barType: 'normal',
					barDims: {
						barWidth  : "10",
						barMargin : "3.4",
						barGroupMargin: ".2",
					},
					chartSelects: {
						chartItems: [
							{
								barGroups: tdata
							}
						],
						selectLabel: null,
					}

				};
				rdata.push(data);
				/*

				console.log('INSECT DAMAGE');
				data.header=20;
				data.left=0;
				data.right=6;
				data.footer=15;
				data.barDims= {
					barWidth  : "14",
					barMargin : "6.0",
					barType   : "single",
				};
				for (let li in data.data) {// eslint-disable-line
					if ('value' in data.data[li]) {
						data.data[li].values=[data.data[li].value];
					}
				}
				dataCon={ data: data.data, value: 'None' };
				data.data=[dataCon];
				rdata.push(data);
				//*/
				data = [];

				return rdata;
				} catch (e) {
					console.log(e);
					return [];
				}

		},
		getSelectedContractNum() {
			return this.$store.getters.selectedContract.contractNum.toString();
		},
		EntitySummaryData() {
			return this.$store.getters.entitySummaryData;
		},
		getContractName() {
			const name = this.$store.getters.selectedContract.contractName;
			return name;
		},
	},

	methods : {
		sendEmail() {
		},
		GrabUpdatedData() {
			const data = this.$store.getters.entitySummaryData;
			return data;
		},
		getAllInsectDamageData() {
			console.log('getAllInsectDamageData');
			const ldata = this.chartData.InsectDamage.chartData.map( item => ( {
				value    : item.data[0] && item.data[0].TotalInsect ? item.data[0].TotalInsect : 0,
				percent  : item.data[0] && item.data[0].TotalInsectPct ? item.data[0].TotalInsectPct : 0,
				label    : item.year,
				barColor : colors.insectColor
			} ) );
			return ( {
				title         : 'Insect Damage',
				subtitle      : 'This shows the overall impact insects had on your crops this year',
				type          : 'InsectBarChart',
				multipleYears : true,
				userBarWidth  : 70,
				options       : {
					userBarWidth : 70,
					hasBarLabels : false
				},
				data: ldata
			} );
		},
		getPayableYieldData() {
			const payableData = this.chartData.PayableYield.chartData.map( variety => ( {
				value      : variety.data.TotalPayable,
				label      : variety.year,
				barColor   : '#ED1C24',
				labelColor : '#ED1C24'
			} ) );
			return ( {
				data          : payableData,
				multipleYears : false,
				options       : {
					hasBarLabels : true
				},
				title    : 'Payable Yield Trends',
				subtitle : 'This shows your payable yield from the last three years'
			} );
		},
		getAllQualitySummaryData() {
			console.log('getAllQualitySummaryData');
			console.log(this.chartData);
			const data = this.chartData.QualitySummary.chartData.map( ( item ) => {
				console.log('start');
				console.log(item);
				const toRet = [];
				let i = 0;


				try {
					// eslint-disable-next-line no-restricted-syntax
					for ( const [key, value] of Object.entries( item.data[0] ) ) {
						console.log('entry');
						toRet.push( {
							label      : key,
							value,
							barColor   : colors.qualityColors[i],
							labelColor : colors.qualityColors[i++],
						} );
					}
				} catch(e) { console.log(e); }
				console.log('return');
				console.log(toRet);
				return ( {

					year : item.year,
					data : toRet

				} );

			} );
			return ( {
				title    : 'Quality Summary',
				subtitle : 'This is the quality of crop you produced this year',
				options  : {
					hasBarLabels : true
				},
				allData       : data,
				type          : 'barChart',
				multipleYears : true
			} );
		},
	},

	created() {
		try {
			console.log('created');
		if ( this.EntitySummaryData.InsectDamage.chartData.length < 1 ) {
			this.$store.dispatch( 'setEntitySummaryDataInsectDamage', this.getSelectedContractNum );
		}
			console.log('get payable yield');

		if ( this.EntitySummaryData.PayableYield.chartData.length < 1 ) {
			this.$store.dispatch( 'setEntitySummaryDataPayableYield', this.getSelectedContractNum );
		}

			console.log('done');
		if ( this.EntitySummaryData.QualitySummary.chartData.length < 1 ) {
			this.$store.dispatch( 'setEntitySummaryDataQualitySummary', this.getSelectedContractNum );
		}



			this.chartData = this.GrabUpdatedData();

		} catch(e) {
			console.log('error in created');
			console.log(e);
		}
		console.log('created done');
	},

	mounted() {

	},

	// were gonna need to sync our props along with our queries when summary filters

	data : () => ( {
		totalPoundsProducedRes : null,
		insectQueryRes         : null,
		qualityQueryRes        : null,
		swiper      : null,
		activeSlide : 0,
		showEmail   : false,
		chartData   : null
	} ),
};
</script>

<style lang="scss"scoped>
.summary-view {
	background: #f1f9f5;
	color: #026a44;
	font-family: $font-serif;
	height: 88%;
}
.barhart {
	background: #CCFFCC;
}
.header {
	text-align: left;
	height: 25%;
	background: $color;
	.title {
		text-align: left;
		font-weight: bold;
		font-size: 5.6vmin;
		font-family: $font-serif;
	}
	.sub-title {
		font-weight: bold;
		font-size: 4.4vmin;
		line-height: 100%;
		font-family: $font-serif;
	}
 }
 .button-section {
	 height: 10%;
	 text-align: left;
	 margin-top: -34px;
	 margin-bottom: 20px;
 }
.chart-section {
	height: 65%;
}
.btn {
	background: $color-secondary;
	box-shadow: 0px 2px 15px rgba(14, 51, 63, 0.15), 0px 2px 3px rgba(14, 51, 63, 0.15);
	border-radius: 50px;
	width: 135px;
	height: 50px;
	font-family: $font-sans-serif;
	border: none;
	font-size: 17px;
}
.btn:hover,
.btn:active,
.btn:focus {
	background: $color-primary;
}
.dark-btn{
	background: $color-primary
}
.graph-card {
	background: $color;
	border-radius: 20px;
}
.swiper-container {
	height: 95%;
}
.swiper-wrapper {
	height: 85%;
}
.chart-title {
	font-family: $font-sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 30px;
	line-height: 30px;
	align-items: center;
	color: #5A726A;
	padding-top: 20px;
}
.chart-sub-title {
	font-family: $font-sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 12px;
	line-height: 12px;
	align-items: center;
	color: #5A726A;
	padding-top: 0px;
}

</style>


